import { createSelector } from '@reduxjs/toolkit';

import { RoofContainer } from '@paragon/contract-library';

import { RootState } from '../index';
import { getSingleSelectedItemEntryOrNull } from './getSelectedItemSelector';

export const getActiveRoofContainer = createSelector(
  getSingleSelectedItemEntryOrNull,
  (state: RootState) => state.layout.roofContainers,

  (selectedEntry, roofContainers): RoofContainer | null => {
    if (selectedEntry == null) return null;

    if (selectedEntry.type === 'roofContainer') {
      return selectedEntry.item;
    }

    if (selectedEntry.type === 'trussEnvelope') {
      return selectedEntry.item.roofContainerGuid != null
        ? (roofContainers[selectedEntry.item.roofContainerGuid] ?? null)
        : null;
    }

    return null;
  },
);
